import React from 'react'
import { Icon } from './Quote.elements'

type Props = {
  className?: string
}

export const QuoteIcon = ({ className }: Props) => (
  <Icon
    aria-hidden
    className={className}
    fill="none"
    focusable={false}
    role="img"
    viewBox="0 0 24 18"
  >
    <path d="M9.26 0c.87.208 1.436.872 1.697 1.993-1.261.664-2.544 1.661-3.848 2.99-1.305 1.328-2.218 2.782-2.74 4.36h.196c1.652 0 2.935.415 3.848 1.245.957.79 1.435 1.827 1.435 3.114 0 1.205-.478 2.222-1.435 3.052C7.5 17.584 6.391 18 5.087 18c-1.565 0-2.804-.519-3.717-1.557C.457 15.363 0 14.076 0 12.58c0-2.533.848-4.796 2.543-6.789C4.24 3.8 6.478 1.87 9.261 0zm13.044 0c.87.208 1.435.872 1.696 1.993-1.26.664-2.544 1.661-3.848 2.99-1.304 1.328-2.217 2.782-2.739 4.36h.196c1.652 0 2.934.415 3.847 1.245.957.79 1.435 1.827 1.435 3.114 0 1.205-.478 2.222-1.434 3.052-.913.83-2.022 1.246-3.327 1.246-1.565 0-2.804-.519-3.717-1.557-.913-1.08-1.37-2.367-1.37-3.862 0-2.533.848-4.796 2.544-6.789C17.283 3.8 19.522 1.87 22.304 0z" fill="currentColor" />
  </Icon>
)
